import { Component, Input, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getSelectedCategory } from '@app/category/reducers/category.reducer';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

@Component({
	selector: 'g-mobile-category-picker',
	templateUrl: './mobile-category-picker.component.html',
	styleUrls: ['./mobile-category-picker.component.scss'],
	standalone: false,
})
export class MobileCategoryPickerComponent {
	private readonly store = inject<Store<RootReducer.State>>(Store);

	@Input() readonly categories: api.CategoryDto[];
	@Input() readonly allCategories: api.CategoryDto[];
	readonly icons = { faCaretDown };
	readonly currentCategory$ = this.store.select(getSelectedCategory);
}
